import type { ReactNode } from "react";
import { Fragment } from "react";

export const interpolate = (term: string, transforms: Record<string, (text: string) => ReactNode>) => {
  const parts = term.split(regex);
  return parts.reduce<ReactNode[]>((accumulator, next, index) => {
    if (index % 3 === 0) accumulator.push(<Fragment key={index}>{next}</Fragment>);
    else if (index % 3 === 1 && next in transforms)
      accumulator.push(<Fragment key={index}>{transforms[next](parts[index + 1])}</Fragment>);
    return accumulator;
  }, []);
};

export const interpolateString = (term: string, transforms: Record<string, (text: string) => string>) => {
  const parts = term.split(regex);
  return parts.reduce<string>((accumulator, next, index) => {
    if (index % 3 === 0) return accumulator + next;
    else if (index % 3 === 1 && next in transforms) return accumulator + transforms[next](parts[index + 1]);
    return accumulator;
  }, "");
};

const regex = /\$\{(.*?):\s(.*?)\}/g;
